import { useState } from 'react';
import { useMediaQuery, useTheme } from '@mui/material';

export function useTestSettings() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  const [dataSelectionExpanded, setDataSelectionExpanded] = useState(!isMobile);
  const [testSettingsExpanded, setTestSettingsExpanded] = useState(!isMobile);
  const [historyDialogOpen, setHistoryDialogOpen] = useState(false);
  const [settingsDialogOpen, setSettingsDialogOpen] = useState(false);

  return {
    dataSelectionExpanded,
    setDataSelectionExpanded,
    testSettingsExpanded,
    setTestSettingsExpanded,
    historyDialogOpen,
    setHistoryDialogOpen,
    settingsDialogOpen,
    setSettingsDialogOpen,
  };
}
